import {useGrpcRequest} from '@aboutyou/data-fetcher';
import {NavigationService_GetHeaderHintsLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/service.grpc.lazy';
import {useFullSession} from '@aboutyou/user';
import {useReductionsStateRequestParameter} from '../../../../features/ReductionsState/useReductionsStateRequestParameter';
import {useTargetGroupIdentifier} from '../../../../shared-deprecated/useTargetGroupIdentifier';

export const useHeaderHints = () => {
  const session = useFullSession();
  return useGrpcRequest(
    NavigationService_GetHeaderHintsLazy,
    {
      reductionsState: useReductionsStateRequestParameter(),
      session,
      targetGroup: useTargetGroupIdentifier(),
    },
    {
      /**
       * This hook is disabled during SSR for the following reasons:
       * - it creates a network waterfall on the server since its called nested within the GetHeaderBulk request
       * - this endpoint's purpose is mainly to handle header icon hints on the browser for logged in users based on their "session" which is not available on the server, so that we can avoid calling the more expensive GetHeaderBulk enpoint
       */
      disabled: !process.browser || !session,
    },
  );
};
